/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import {
  Container,
  ContainerRow,
  ContainerView,
  DesktopContainer,
  MobileContainer,
} from "../../components/Container";
import { TitleWithBack } from "../../components/Layout";
import { cryptoType, gameType, useApp } from "../../contexts";
import { useEffect, useCallback, useState } from "react";
import {
  FilterRow,
  FilterRowItem,
  OptionTypeTransaction,
} from "./styles";
import { FormButton, FormItem, FormSelect } from "../../components/Form";
import FormButton2 from "../../components/FormCustom2/Button";
import FormInput from "../../components/FormCustom2/Input";
import { Col, Form, Row, Tabs } from "antd";
import { CellRowImage, CellRowValue, EqualIcon2 } from "../wallet-list/styles";
import {
  CellStatus,
  ContainerTable,
  paginationRender,
  PaginationView,
  TableView,
} from "../../components/Table";
import {
  formatCurrency,
  getTransactionList,
  roundNumber,
  statusConvert,
  typeConvert,
} from "../../services/app";
import moment from "moment";
import Detail from "./detail";
import produce from "immer";
import {
  Alert,
  AlertBg,
  AlertContent,
  AlertText,
  ErrorIcon,
  SuccessIcon,
} from "../withdraw/styles";
import { Copy } from "../../components/Copy";
import { DatePickerView } from "../../components/DatePicker";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import TabsCustom from "../../components/TabsCustom";
import { isMobile } from "react-device-detect";
import { FilterMbIcon } from "../../components/Icons/FilterMbIcon";
import { CopyIcon } from "../../components/Icons/CopyIcon";
import { WithDrawIcon } from "../../components/Icons/WithDrawIcon";
import { DepositIcon } from "../../components/Icons/DepositIcon";
import { TransferIcon } from "../../components/Icons/TransferIcon";
import TransactionItem from "./TransactionItem";
import {
  StatusSort,
  statusFilterTransaction1,
  statusFilterTransaction2,
  tabTransactionOptions,
} from "../../constants";
import ModalFilter from "./ModalFilter";
import EmptyTable from "../../components/EmptyTable";
import EmptyTableMobile from "../../components/EmptyTableMobile";
import { useWindowSize } from "../../hook/useWindowSize";
import { typeTransactionOptions } from "../../constants";
import { Swiper, SwiperSlide } from "swiper/react";
import OptionTypeTransactionItem from "./OptionTypeTransactionItem";
import { getCoinCodeImage, isSOTd } from "../../utils/helper";

export const getValueByTab = (tab, values) => {
  if (values.length === 2) {
    if (tab === "crypto" || tab === "option") {
      return values[0];
    }
    return values[1];
  } else if (values.length === 3) {
    if (tab === "crypto") {
      return values[0];
    }
    if (tab === "option") {
      return values[1];
    }
    return values[2];
  } else {
    if (tab === "crypto") {
      return values[0];
    }
    if (tab === "option") {
      return values[1];
    }
    if (tab === "gameCurrency" || tab === "game" || tab === "sztConversion") {
      return values[2];
    }
    return values[3];
  }
};

export default function TransactionHistory(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    setLoading,
    currencies,
    convertToCurrency,
    language,
    user,
  } = useApp();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let { type, id, code, walletId } = {
    type: searchParams.get("type"),
    id: searchParams.get("id"),
    code: searchParams.get("code"),
    walletId: searchParams.get("walletId"),
    fromType: searchParams.get("fromType"),
    ...(useParams() || {}),
  };

  const [tab, setTab] = useState(
    getValueByTab(type, ["crypto", "option", "sztConversion", "commission"])
  );
  const [alert, setAlert] = useState("");
  const [datePicker, setDatePicker] = useState(false);
  const [sortBTC, setSortBTC] = useState(StatusSort.none);
  const [isOpenModalFilter, setIsOpenModalFilter] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const onCell = (record, rowIndex) => {
    return {
      onClick: (event) => {
        if (!event.target.classList.contains("copy")) {
          setRow(record);
        }
      },
    };
  };

  const initQuery = () => {
    return getValueByTab(tab, [
      {
        option: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === gameType
              ? code
              : null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 1,
        },
        crypto: {
          currencyCode:
            currencies?.find((item) => item.code === code)?.type === cryptoType
              ? code
              : null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 1,
        },
        game: {
          fromCurrencyCode: null,
          currencyCode: null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 1,
        },
        commission: {
          fromCurrencyCode: null,
          currencyCode: null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 2,
        },
      },
      {
        option: {
          currencyCode: null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 1,
        },
        crypto: {
          currencyCode: null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 1,
        },
        game: {
          fromCurrencyCode:
            currencies?.find((item) => item.code === code)?.type === gameType
              ? code
              : null,
          currencyCode: null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 1,
        },
        commission: {
          fromCurrencyCode: null,
          currencyCode: null,
          date: null,
          transactionType: null,
          transactionStatus: null,
          fromType: 2,
        },
      },
    ]);
  };
  const [query, setQuery] = useState(initQuery());
  const [querySubmit, setQuerySubmit] = useState(initQuery());
  const [convertValue, setConvertValue] = useState([]);
  const [row, setRow] = useState();
  const [form] = Form.useForm();

  const toggleModalFilter = () => {
    setIsOpenModalFilter((prev) => !prev);
  };
  const getIconType = (type) => {
    switch (type) {
      case "withdraw":
      case "checkout":
        return <WithDrawIcon />;
      case "deposit":
        return <DepositIcon />;
      case "transfer":
        return <TransferIcon />;
      default:
        return <TransferIcon />;
    }
  };

  const columns = [
    {
      title: T("Transaction ID"),
      dataIndex: "code",
      key: "code",
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <Copy
            textStyle={{ fontWeight: 400, fontSize: 16 }}
            cutText={true}
            splitFont={5}
            numDot={3}
            text={text}
            icon={<CopyIcon />}
          />
        );
      },
    },
    ...getValueByTab(tab, [
      [
        {
          title: T("Type"),
          dataIndex: "type",
          key: "type",
          onCell: onCell,
          render: (text, record, index) => {
            const val = text.split(" ").join("_");
            return (
              <div className="flex items-center gap-[6px]">
                <span> {getIconType(val)}</span>
                <span className="text-[#000000] font-normal text-[16px] leading-[25px]">
                  {T(text)}
                </span>
              </div>
            );
          },
        },
        {
          title: T("Coin"),
          dataIndex: "coin",
          key: "coin",
          onCell: onCell,
          render: (text, record, index) => {
            return text || record?.coinFrom ? (
              <CellRowImage className="v2">
                <img
                  alt={" "}
                  style={{ width: 28, height: 28 }}
                  src={`/assets/images/otc/crypto/${getCoinCodeImage(
                    text || record?.coinFrom
                  )?.toLowerCase()}.svg`}
                />
                <span>{text || record?.coinFrom}</span>
              </CellRowImage>
            ) : (
              <CellRowImage className="v2">
                <div
                  style={{
                    width: 28,
                    height: 28,
                    backgroundColor: "#f8f8f8",
                    borderRadius: 32,
                  }}
                ></div>
              </CellRowImage>
            );
          },
        },
        {
          title: T("Amount"),
          dataIndex: "amount",
          key: "amount",
          onCell: onCell,
          render: (text, record, index) => {
            return <span className="text-[16px]">{formatCurrency(text, null, getCurrency())}</span>;
          },
        },
      ],
      [
        {
          title: T("From Currency"),
          dataIndex: "coinFrom",
          key: "coinFrom",
          onCell: onCell,
          render: (text, record, index) => {
            return text ? (
              <CellRowImage className="v2">
                <img
                  alt=""
                  style={{ width: 28, height: 28 }}
                  src={`/assets/images/otc/crypto/${
                    getCoinCodeImage(text)?.toLowerCase() || ""
                  }.svg`}
                />
                <div>
                  <span style={{ fontSize: 15, fontWeight: 400 }}>{text}</span>
                  <br />
                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    {formatCurrency(record?.amount, null, getCurrency())}
                  </span>
                </div>
              </CellRowImage>
            ) : null;
          },
        },
        {
          title: T("To Currency"),
          dataIndex: "coin",
          key: "coin",
          onCell: onCell,
          render: (text, record, index) => {
            return text ? (
              <CellRowImage className="v2">
                <img
                  alt=""
                  style={{ width: 28, height: 28 }}
                  src={`/assets/images/otc/crypto/${getCoinCodeImage(
                    text
                  )?.toLowerCase()}.svg`}
                />
                <div>
                  <span style={{ fontSize: 15, fontWeight: 400 }}>{text}</span>
                  <br />
                  <span style={{ fontSize: 16, fontWeight: 600 }}>
                    {formatCurrency(record?.toAmount, null, getCurrency())}
                  </span>
                </div>
              </CellRowImage>
            ) : null;
          },
        },
      ],
    ]),

    {
      title: T("BTC Value"),
      dataIndex: "btc",
      key: "btc",
      align: "right",
      sorter: (a, b) => parseFloat(a.btc) - parseFloat(b.btc),
      onCell: onCell,
      render: (text, record, index) => {
        return (
          <CellRowValue
          >
            <div className="flex flex-col gap-1 items-end">
              <p className="text-[16px] font-normal">{formatCurrency(text, null, getCurrency())}</p>
              <span className="text-right">
                <EqualIcon2 />
                <span
                  style={{
                    fontSize: 14,
                    color: "#818181",
                    fontWeight: 400,
                    marginLeft: 7,
                  }}
                >
                  {formatLocalCurrency(record.local)}
                </span>
              </span>
            </div>
          </CellRowValue>
        );
      },
    },
    {
      title: T("Status"),
      dataIndex: "status",
      key: "status",
      onCell: onCell,
      render: (text, record, index) => {
        return <CellStatus text={text}>{T(text)}</CellStatus>;
      },
    },
    {
      title: T("Time"),
      dataIndex: "time",
      key: "time",
      onCell: onCell,
      sorter: (a, b) =>
        moment(a.time, "YYYY/MM/DD HH:mm:sss").toDate().getTime() -
        moment(b.time, "YYYY/MM/DD HH:mm:sss").toDate().getTime(),
      render: (val) => (
        <span style={{ color: "#818181", fontSize: 16, fontWeight: 400 }}>
          {val}
        </span>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    if (field === "btc") {
      setSortBTC(order);
    }
  };

  useEffect(() => {
    if (id) {
      setRow({ id });
    }
  }, []);

  useEffect(() => {
    loadData().then();
  }, [page, querySubmit, tab]);

  useEffect(() => {
    let timer;
    if (alert) {
      timer = setTimeout(() => setAlert(""), 2000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [alert]);

  const convertData = useCallback(() => {
    return rows.map((item) => {
      let status = statusConvert(item);
      let itemType = typeConvert(item);
      const convertCode =
        item?.type === 1 ||
        item?.type === 5 ||
        item?.type === 7 ||
        item?.type === 6
          ? item.dest_currency_code
          : item.from_currency_code;
      return {
        ...item,
        local: convertToLocalCurrency(item.amount, convertCode, getCurrency()),
        id: item.id,
        transactionId: item.id,
        type: itemType,
        coin: item.dest_currency_code,
        coinFrom: item.from_currency_code,
        toAmount: convertToCurrency(
          item.amount,
          item.from_currency_code,
          item.dest_currency_code,
          getCurrency()
        ),
        amount: item.amount,
        btc: convertToBTC(item.amount, convertCode, getCurrency()),
        status: status,
        time: moment(item.created_time).format("YYYY/MM/DD HH:mm:ss"),
      };
    });
  }, [
    convertToBTC,
    convertToCurrency,
    convertToLocalCurrency,
    getCurrency,
    rows,
  ]);

  const loadData = async () => {
    setLoading(true);
    const data = getValueByTab(tab, [
      querySubmit.crypto,
      querySubmit.option,
      querySubmit.game,
      querySubmit.commission,
    ]);
    let result = await getTransactionList({
      currencyType: getValueByTab(tab, [1, 4, 2]),
      page: page,
      size: 15,
      ...data,
      ...getValueByTab(tab, [{}, {}, {}]),
    });
    if (result.status === 200) {
      const data = result?.data?.data?.transactions?.rows || [];
      setTotal(result?.data?.data?.transactions?.count || 0);
      setRows(data);
    }
    setLoading(false);
  };

  const onBack = () => {
    if (type && walletId) {
      navigate(`/wallet-detail/${type}/${walletId}`);
    } else {
      navigate(`/`);
    }
  };

  const onSearch = (reset = false) => {
    setLoading(true);
    if (reset) {
      setQuerySubmit(initQuery());
    } else {
      setQuerySubmit(JSON.parse(JSON.stringify(query)));
    }
    setIsOpenModalFilter(false);
  };

  const handleReset = () => {
    setQuery(initQuery());
    onSearch(true);
    setIsOpenModalFilter(false);
  };

  const handleChangeTime = (value) => {
    setQuery(
      produce((draft) => {
        if (value !== "customized") {
          draft[fieldTabName].date = value;
        }
        switch (value) {
          case "7days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(7, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "30days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(30, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "60days": {
            draft[fieldTabName].fromDate = moment()
              .startOf("day")
              .subtract(60, "days")
              .toDate()
              .getTime();
            draft[fieldTabName].toDate = moment()
              .endOf("day")
              .toDate()
              .getTime();
            break;
          }
          case "customized": {
            setDatePicker(true);
            break;
          }
          default: {
            draft[fieldTabName].fromDate = undefined;
            draft[fieldTabName].toDate = undefined;
          }
        }
      })
    );
  };

  const values = convertValue || [];
  const fieldTabName = getValueByTab(tab, ["crypto", "option", "game"]);
  const queryTabValue = getValueByTab(tab, [
    query?.crypto,
    query?.option,
    query?.game,
    query?.commission,
  ]);

  const handleSort = () => {
    if (!sortBTC) {
      setSortBTC(StatusSort.descend);
    }
    if (sortBTC === StatusSort.descend) {
      setSortBTC(StatusSort.ascend);
    }
    if (sortBTC === StatusSort.ascend) {
      setSortBTC(StatusSort.none);
    }
  };

  const renderItemMobile = () => {
    let isSorted = false;
    const valueClone = [...values];
    const valueSorted = valueClone?.sort((a, b) => {
      if (sortBTC === StatusSort.ascend) {
        isSorted = true;
        return b.btc - a.btc;
      }
      if (sortBTC === StatusSort.descend) {
        isSorted = true;
        return a.btc - b.btc;
      }
    });

    return (
      <Row gutter={[0, 20]}>
        {values?.length ? (
          (isSorted ? valueSorted : values)?.map((item) => (
            <Col key={item.id} span={24} onClick={() => setRow(item)}>
              <TransactionItem
                handleSort={handleSort}
                sorted={sortBTC}
                version={tab === "sztConversion" ? 2 : 1}
                item={item}
              />
            </Col>
          ))
        ) : (
          <div className="w-full flex justify-center pt-[10px]">
            <EmptyTableMobile T={T} />
          </div>
        )}
      </Row>
    );
  };

  useEffect(() => {
    setConvertValue(convertData);
  }, [convertData, rows]);

  const size = useWindowSize();

  return (
    <Container>
      <ContainerView>
        <div className="mt-4">
          <TitleWithBack
            mb={isMobile ? 40 : 54}
            title={T("Transaction History")}
            onClick={onBack}
          />
        </div>
        <DesktopContainer>
          <div className="relative">
            <TabsCustom
              className="v2 sticky"
              activeKey={tab}
              onChange={(e) => setTab(e)}
            >
              {tabTransactionOptions?.map((tabType) => (
                <Tabs.TabPane
                  tab={T(tabType.label)}
                  key={tabType.value}
                ></Tabs.TabPane>
              ))}
            </TabsCustom>
            <div
              className="absolute right-0 bottom-6 cursor-pointer lg:hidden"
              onClick={toggleModalFilter}
            >
              <FilterMbIcon />
            </div>
          </div>
        </DesktopContainer>
        <MobileContainer>
          <OptionTypeTransaction className={"showOver"}>
            <Swiper
              slidesPerView={size.width < 768 ? 3 : 5}
              spaceBetween={10}
              grabCursor={true}
              pagination={false}
              watchOverflow={true}
              navigation={true}
            >
              {tabTransactionOptions.map((typeTab, index) => {
                return (
                  <SwiperSlide>
                    <OptionTypeTransactionItem
                      checked={tab === typeTab.value}
                      value={typeTab.value}
                      label={T(typeTab.label)}
                      onChange={(val, checked) => {
                        setTab(val);
                      }}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </OptionTypeTransaction>
          {/*  */}
          <div className="relative mt-[35px]">
            <TabsCustom
              className="v2 sticky"
              activeKey={queryTabValue?.transactionType ?? ""}
              onChange={(value) => {
                setQuery(
                  produce((draft) => {
                    draft[fieldTabName].transactionType = value;
                    setQuerySubmit(JSON.parse(JSON.stringify(draft)));
                  })
                );
              }}
            >
              {typeTransactionOptions(tab, user.country_code)?.map(
                (tabType) => (
                  <Tabs.TabPane
                    tab={T(tabType.label)}
                    key={tabType.value}
                  ></Tabs.TabPane>
                )
              )}
            </TabsCustom>
            <div
              className="lg:hidden flex h-[35px] items-center justify-center rounded-3xl gap-[8px] bg-white w-[100px]"
              onClick={toggleModalFilter}
            >
              <FilterMbIcon />
              <span className="text-[14px] leading-[26px] text-[#000]">
                {T("Filter")}
              </span>
            </div>
          </div>
        </MobileContainer>
        <DesktopContainer>
          <Form ref={form} className="mt-[34px] lg:mt-[37px]">
            <FilterRow>
              <FilterRowItem>
                <FormItem label={T("Time")}>
                  <FormSelect
                    allowClear={false}
                    value={queryTabValue?.date}
                    onSelect={(value) => {
                      switch (value) {
                        case "customized":
                          setDatePicker(true);
                          break;
                        default:
                          break;
                      }
                    }}
                    onChange={handleChangeTime}
                  >
                    <FormSelect.Option value={null}>
                      {T("All")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"7days"}>
                      {T("Last 7 days")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"30days"}>
                      {T("Last 30 days")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"60days"}>
                      {T("Last 60 days")}
                    </FormSelect.Option>
                    <FormSelect.Option value={"customized"}>
                      {query[fieldTabName].date === "customized"
                        ? `${moment(query[fieldTabName].fromDate).format(
                            "DD/MM/YYYY"
                          )} - ${moment(query[fieldTabName].toDate).format(
                            "DD/MM/YYYY"
                          )}`
                        : T("Customized")}
                    </FormSelect.Option>
                  </FormSelect>
                </FormItem>
              </FilterRowItem>
              {tab === "crypto" || tab === "option" ? (
                <>
                  <FilterRowItem>
                    <FormItem label={T("Coin")}>
                      <FormSelect
                        allowClear={false}
                        value={queryTabValue?.currencyCode}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].currencyCode = value;
                            })
                          )
                        }
                      >
                        <FormSelect.Option value={null}>
                          {T("All")}
                        </FormSelect.Option>

                        {currencies
                          .filter((item) =>
                            getValueByTab(tab, [
                              item.type === cryptoType,
                              isSOTd(item.code),
                              item.type === gameType && !isSOTd(item.code),
                            ])
                          )
                          .map((item, index) => {
                            return (
                              <FormSelect.Option
                                key={index.toString()}
                                value={item.code}
                              >{`${T(item.name)} (${
                                item.code
                              })`}</FormSelect.Option>
                            );
                          })}
                      </FormSelect>
                    </FormItem>
                  </FilterRowItem>
                  <FilterRowItem>
                    <FormItem label={T("Type")}>
                      <FormSelect
                        allowClear={false}
                        value={queryTabValue?.transactionType ?? ""}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].transactionType = value;
                            })
                          )
                        }
                      >
                        {typeTransactionOptions(tab, user.country_code).map(
                          (type, index) => (
                            <FormSelect.Option
                              key={index.toString()}
                              value={type.value}
                            >
                              {T(type.label)}
                            </FormSelect.Option>
                          )
                        )}
                      </FormSelect>
                    </FormItem>
                  </FilterRowItem>
                  <FilterRowItem>
                    <FormItem label={T("Status")}>
                      <FormSelect
                        allowClear={false}
                        value={queryTabValue?.transactionStatus}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].transactionStatus = value;
                            })
                          )
                        }
                      >
                        <FormSelect.Option value={null}>
                          {T("All")}
                        </FormSelect.Option>
                        {tab === "crypto" || tab === "option"
                          ? statusFilterTransaction1.map((status) => (
                              <FormSelect.Option value={status.value}>
                                {T(status.label)}
                              </FormSelect.Option>
                            ))
                          : statusFilterTransaction2.map((status) => (
                              <FormSelect.Option value={status.value}>
                                {T(status.label)}
                              </FormSelect.Option>
                            ))}
                      </FormSelect>
                    </FormItem>
                  </FilterRowItem>
                </>
              ) : (
                <>
                  <FilterRowItem>
                    <FormItem label={T("From Currency")}>
                      <FormSelect
                        allowClear={false}
                        value={queryTabValue?.fromCurrencyCode}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].fromCurrencyCode = value;
                            })
                          )
                        }
                      >
                        <FormSelect.Option value={null}>
                          {T("All")}
                        </FormSelect.Option>
                        {currencies
                          .filter((item) =>
                            getValueByTab(tab, [
                              item.type === cryptoType,
                              isSOTd(item.code),
                              item.type === gameType && !isSOTd(item.code),
                              // item.type === gameType && (!isSOTd({currency_code: item.code}) || isSOTd({currency_code: item.code}) && item?.can_auto_withdraw !== 1)
                            ])
                          )
                          .map((item, index) => {
                            return (
                              <FormSelect.Option
                                key={index.toString()}
                                value={item.code}
                              >{`${T(item.name)} (${
                                item.code
                              })`}</FormSelect.Option>
                            );
                          })}
                      </FormSelect>
                    </FormItem>
                  </FilterRowItem>
                  <FilterRowItem>
                    <FormItem label={T("To Currency")}>
                      <FormSelect
                        allowClear={false}
                        value={queryTabValue?.currencyCode}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].currencyCode = value;
                            })
                          )
                        }
                      >
                        <FormSelect.Option value={null}>
                          {T("All")}
                        </FormSelect.Option>

                        {currencies
                          .filter((item) => item.type === cryptoType)
                          .map((item, index) => {
                            return (
                              <FormSelect.Option
                                key={index.toString()}
                                value={item.code}
                              >{`${T(item.name)} (${
                                item.code
                              })`}</FormSelect.Option>
                            );
                          })}
                      </FormSelect>
                    </FormItem>
                  </FilterRowItem>
                  <FilterRowItem>
                    <FormItem label={T("Status")}>
                      <FormSelect
                        allowClear={false}
                        value={queryTabValue?.transactionStatus}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].transactionStatus = value;
                            })
                          )
                        }
                      >
                        <FormSelect.Option value={null}>
                          {T("All")}
                        </FormSelect.Option>
                        {tab === "crypto"
                          ? statusFilterTransaction1.map((status) => (
                              <FormSelect.Option value={status.value}>
                                {T(status.label)}
                              </FormSelect.Option>
                            ))
                          : statusFilterTransaction2.map((status) => (
                              <FormSelect.Option value={status.value}>
                                {T(status.label)}
                              </FormSelect.Option>
                            ))}
                      </FormSelect>
                    </FormItem>
                  </FilterRowItem>
                </>
              )}
            </FilterRow>
            <DesktopContainer>
              <FilterRow>
                {tab !== "crypto" && tab !== "option" ? (
                  <FilterRowItem>
                    <FormItem label={T("Transaction ID")}>
                      <FormInput
                        value={queryTabValue?.transactionId}
                        onChange={(value) =>
                          setQuery(
                            produce((draft) => {
                              draft[fieldTabName].transactionId =
                                value.target.value;
                            })
                          )
                        }
                        placeholder={T("Please enter Transaction ID")}
                      />
                    </FormItem>
                  </FilterRowItem>
                ) : null}
                {tab === "crypto" || tab === "option" ? (
                  <>
                    <FilterRowItem>
                      <FormItem label={T("Transaction ID")}>
                        <FormInput
                          value={queryTabValue?.transactionId}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].transactionId =
                                  value.target.value;
                              })
                            )
                          }
                          placeholder={T("Please enter Transaction ID")}
                        />
                      </FormItem>
                    </FilterRowItem>

                    <FilterRowItem>
                      <FormItem label={T("From Address")}>
                        <FormInput
                          value={queryTabValue?.fromAddress}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].fromAddress =
                                  value.target.value;
                              })
                            )
                          }
                          placeholder={T("Please enter sender’s address")}
                        />
                      </FormItem>
                    </FilterRowItem>

                    <FilterRowItem>
                      <FormItem label={T("To Address")}>
                        <FormInput
                          value={queryTabValue?.destAddress}
                          onChange={(value) =>
                            setQuery(
                              produce((draft) => {
                                draft[fieldTabName].destAddress =
                                  value.target.value;
                              })
                            )
                          }
                          placeholder={T("Please enter recipient’s address")}
                        />
                      </FormItem>
                    </FilterRowItem>
                  </>
                ) : null}

                <FilterRowItem>
                  <ContainerRow style={{ justifyContent: "flex-end" }}>
                    <FormButton2
                      style={{ width: "50%" }}
                      className="black"
                      height={52}
                      width={144}
                      onClick={handleReset}
                    >
                      {T("Refresh")}
                    </FormButton2>
                    <ContainerRow style={{ width: 10 }} />
                    <FormButton
                      onClick={() => onSearch()}
                      style={{
                        minWidth: 144,
                        width: language === "ja" ? "auto" : "100%",
                      }}
                    >
                      {T("Search")}
                    </FormButton>
                  </ContainerRow>
                </FilterRowItem>
              </FilterRow>
            </DesktopContainer>
          </Form>
        </DesktopContainer>
        <>
          <DesktopContainer>
            <Container style={{ height: 78 }} />
            <ContainerTable>
              <TableView
                locale={{ emptyText: <EmptyTable T={T} /> }}
                scroll={{ x: true }}
                pagination={false}
                dataSource={values}
                columns={columns}
                onChange={handleTableChange}
              />
            </ContainerTable>
          </DesktopContainer>
          <MobileContainer>
            <Container style={{ height: 50 }} />
            {renderItemMobile()}
          </MobileContainer>
        </>
        {total / 15 > 1 ? (
          <PaginationView
            current={page}
            pageSize={15}
            onChange={(p, ps) => {
              setPage(p);
            }}
            total={total}
            itemRender={paginationRender}
          />
        ) : null}
      </ContainerView>

      {row ? (
        <Detail
          id={row.id}
          type={tab}
          onClose={(event) => {
            setRow(null);
            setAlert(event);
            loadData();
          }}
        />
      ) : null}

      {alert === "success" ? (
        <Alert>
          <AlertBg />
          <AlertContent>
            <SuccessIcon />
            <AlertText style={{ color: "#4D67C1" }}>
              {T("Your withdrawal request has been canceled")}
            </AlertText>
          </AlertContent>
        </Alert>
      ) : null}
      {alert === "error" ? (
        <Alert>
          <AlertBg />
          <AlertContent>
            <ErrorIcon />
            <AlertText style={{ color: "#E01B1B" }}>
              {T(
                "Failed to cancel your withdrawal request. Please try again later or contact customer support."
              )}
            </AlertText>
          </AlertContent>
        </Alert>
      ) : null}

      {datePicker ? (
        <DatePickerView
          fromDate={query[fieldTabName].fromDate}
          toDate={query[fieldTabName].toDate}
          onCancel={() => {
            setDatePicker(false);
          }}
          onChange={(event) => {
            setQuery(
              produce((draft) => {
                draft[fieldTabName].date = "customized";
                draft[fieldTabName].fromDate = event.fromDate
                  .startOf("day")
                  .toDate()
                  .getTime();
                draft[fieldTabName].toDate = event.toDate
                  .endOf("day")
                  .toDate()
                  .getTime();
              })
            );
            setDatePicker(false);
          }}
        />
      ) : null}
      {isOpenModalFilter && (
        <ModalFilter
          setDatePicker={setDatePicker}
          handleChangeTime={handleChangeTime}
          queryTabValue={queryTabValue}
          fieldTabName={fieldTabName}
          onSearch={onSearch}
          onReset={handleReset}
          setQuery={setQuery}
          tab={tab}
          onClose={toggleModalFilter}
        />
      )}
    </Container>
  );
}
